<template>
  <div class="estimate" v-html="content" v-if="content"></div>
</template>

<script>
function debounce(fn, wait) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer); // clear any pre-existing timer
    }
    const context = this; // get the current context
    timer = setTimeout(() => {
      fn.apply(context, args); // call the function if time expires
    }, wait);
  };
}

import axios from "axios";

export default {
  name: "EstimateRefund",
  data: function () {
    return {
      content: "",
    };
  },
  props: {
    template: String,
    form: Object,
    operationId: String,
  },
  created() {
    this.debouncedEstimate = debounce(async () => {
      const omitedFields = [
        "rib",
        "bar_code",
        "receipt",
        "id_proof",
        "file_1",
        "file_2",
        "file_3",
        "file_4",
        "file_5",
        "last_name",
        "first_name",
        "email",
        "phone",
        "address",
        "iban",
      ];
      const form = { ...this.form };
      omitedFields.forEach((field) => {
        delete form[field];
      });

      const { data } = await axios.post(
        (window.promodevServer || "https://api.lucien.ai") +
          "/api/v2/submissions/estimaterefund",
        {
          form: form,
          operationId: this.operationId,
        },
      );

      const amount_to_refund = Math.ceil(data.estimate) / 100;
      const newContent = this.template
        .replace(
          new RegExp(`{{amount_to_refund}}`, "g"),
          `<span class="amount">${amount_to_refund.toLocaleString("fr-FR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}</span>`,
        )
        .replace(new RegExp(`{{amount_to_refund_raw}}`, "g"), data.estimate);
      if (newContent !== this.content) {
        this.content = newContent;
      }
    }, 500);
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler() {
        if (this.debouncedEstimate) {
          this.debouncedEstimate();
        }
      },
    },
  },
  computed: {},
};
</script>
